import { render, staticRenderFns } from "./TaskFilters.vue?vue&type=template&id=670fab48&scoped=true&"
import script from "./TaskFilters.vue?vue&type=script&lang=js&"
export * from "./TaskFilters.vue?vue&type=script&lang=js&"
import style0 from "./TaskFilters.vue?vue&type=style&index=0&id=670fab48&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670fab48",
  null
  
)

export default component.exports